import { createContext } from 'react';

const EphemeralPresenceManagerContext = /*#__PURE__*/createContext(undefined);

export { EphemeralPresenceManagerContext };
